<template>
  <section> 
    <b-row>
      <b-col>
        <b-card
          style="max-width: 100%"
          >
          <template v-slot:header >
            <div class="header-card text-left">
              <h4>sw-saveform</h4>
              <span class="sw-card-header">Componente para guardar y enviar los datos al backend</span>
            </div>          
          </template>
        </b-card>
      </b-col>
    </b-row>          
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'

export default { 
  name: "forms_saveform",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
     
  }
}
</script>
